import React from "react";
// import SingleProduct from "../components/SingleProduct";

const TraceProductPage = () => {

  return (
    <>
      <main className="my-3 mx-3">
        <h3 className="mt-5 mb-4 mx-2">Track your products </h3>
        {/* <SingleProduct/>
         */}
      </main>
    </>
  );
};

export default TraceProductPage;
